import { MarketType } from '@ha/api-v2/types/inventory/Property';
import { UnitType } from '@ha/api-v2/types/inventory/UnitType';

import { FacilitiesValues } from 'ha/models/ListingFacilities/constants';

import { MarketTypeVariant } from 'ha/modules/PBSA/types';

export const MarketTypeAnalyticsMap: Record<MarketType, MarketTypeVariant[]> = {
  [MarketType.StudentHousing]: [MarketTypeVariant.STUDENT_HOUSING],
  [MarketType.CoLiving]: [MarketTypeVariant.CO_LIVING],
  [MarketType.Other]: [],
};

export const getMarketType = (unitType?: {
  facilities: Partial<UnitType['facilities']>;
}): MarketType => {
  if (unitType?.facilities?.co_living === FacilitiesValues.Yes) {
    return MarketType.CoLiving;
  }

  if (unitType?.facilities?.student_housing === FacilitiesValues.Yes) {
    return MarketType.StudentHousing;
  }

  return MarketType.Other;
};

export const getMarketTypeAnalytics = (unitType?: {
  facilities: Partial<UnitType['facilities']>;
}): MarketTypeVariant[] => {
  const marketType = getMarketType(unitType);

  return MarketTypeAnalyticsMap[marketType] || [];
};
